import React from 'react'
import styles from './LineLinkModal.module.css'
import { useAbTestGtm } from '@/components/utils/abTest'

type LineLinkModalProps = {
    lineUrl: string
    onClose: () => void
}

// DEV-3392 B〜Dで、ページから外したKUZEN(LINE連携)バナーの代わりに出すモーダル。
// 「LINEから受け取る」はA（現行）のLINE連携バナーと同じURLを使う。
export const LineLinkModal = ({ lineUrl, onClose }: LineLinkModalProps) => {
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div
            className={styles.overlay}
            onClick={onClose}
            data-view-label={dataViewLabel('Thanks_CT_LINE-連携モーダル')}
            data-click-label={dataClickLabel('Thanks_CT_LINE-連携モーダル_オーバーレイ')}
        >
            <div className={styles.modalWrapper} onClick={(e) => e.stopPropagation()}>
                <button
                    className={styles.closeButton}
                    onClick={onClose}
                    type='button'
                    aria-label='閉じる'
                    data-click-label={dataClickLabel('Thanks_CT_LINE-連携モーダル_閉じる')}
                />
                <div className={styles.modal}>
                    <img
                        src='/pages/abtest/dev3392/line_modal_banner.png'
                        alt='LINE公式アカウントの友だち特典 “1分”でわかる面談ガイドブック無料プレゼント！'
                        className={styles.banner}
                    />
                    <div className={styles.buttons}>
                        <button
                            className={`${styles.button} ${styles.laterButton}`}
                            onClick={onClose}
                            type='button'
                            data-click-label={dataClickLabel('Thanks_CT_LINE-連携モーダル_戻る')}
                        >
                            今は
                            <br />
                            後にする
                        </button>
                        <a
                            className={`${styles.button} ${styles.lineButton}`}
                            href={lineUrl}
                            data-click-label={dataClickLabel('Thanks_CT_LINE-連携モーダル_CTAボタン')}
                        >
                            LINEから
                            <br />
                            受け取る
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LineLinkModal
